import {
  Tooltip,
  Typography,
  Card,
  CardContent,
} from '@mui/material';
import CircularProgressBar from '../../../Components/CircularProgressbar/circularProgressbar';
import * as employeeAchievementUtils from './employeeAchievementDetailsUtil';
import PropTypes from 'prop-types';

const DriDetailCard = ({score}) => {
  return (
    <div className="profile-dri-mobile" >
      <Card>
        <CardContent className="dri-content">
          <Tooltip
            title={score.driSpecification}
            classes={{ tooltip: 'map-role-btn-tooltip' }}
            disableHoverListener={score.driSpecification.length < 19}
          >
            <Tooltip>
              <Typography>
                {score.driSpecification.length > 19
                  ? `${score.driSpecification.substring(0, 19)}...`
                  : score.driSpecification}
              </Typography>
            </Tooltip>
          </Tooltip>
          <CircularProgressBar
            value={score.driScore}
            progressBarCss={`dri-progress-bar ${employeeAchievementUtils.getColorForDRIScore(
              score.driScore,
            )}`}
            text={score.driScore}
          />
        </CardContent>
      </Card>
    </div>
  );
};

export default DriDetailCard;

DriDetailCard.propTypes = {
  score: PropTypes.any.isRequired,
};
